import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import { BiteServicePorts } from "./bite_service_ports.js";
import "./pinata_api_server.js";
//#region src/pinata_api_server_helper.ts
var pinata_api_server_helper_exports = /* @__PURE__ */ __exportAll({
	apiBaseUrl: () => apiBaseUrl,
	name: () => name
});
function name(pinataApiServer) {
	switch (pinataApiServer) {
		case 2: return "Digital Ocean";
		case 3: return "Localhost";
	}
}
function apiBaseUrl(pinataApiServer) {
	switch (pinataApiServer) {
		case 2: return "https://pinata-2-4z4lh.ondigitalocean.app/";
		case 3: return `http://localhost:${BiteServicePorts.Pinata}`;
	}
}
//#endregion
export { apiBaseUrl, name, pinata_api_server_helper_exports };

//# sourceMappingURL=pinata_api_server_helper.js.map